/* eslint-disable */
import React from 'react';

import Drawer from 'components/Drawer';
import Brand from 'components/_base/Brand';
import LoggedUser from 'components/LoggedUser';
import Notifications from 'components/Notifications';
import NotificacaoChamados from 'components/NotificacaoChamados';

import './styles.scss';

const HeaderApp = () => {
  return (
    <header className="header-app">
      <Drawer />
      <div className="brand-app">
        <a href="/">
          <Brand white />
        </a>
      </div>
      <LoggedUser />
      <NotificacaoChamados />
      <Notifications />
    </header>
  );
};

export default HeaderApp;
